import React, { useState, useEffect } from "react";
import { fetchJson } from "../../lib/Fetching";
import styled, { css } from "styled-components";
import Link from "../Link";
import moment from "moment";

const Wrapper = styled.div`
  max-width: 1200px;
  padding: 10px;
  border-top: 0px;
  margin: 0 auto;
`;

export default function SampleResults({ sample, onClose }) {
  const [sampleReports, setSampleReports] = useState([]);
  const [showReports, setShowReports] = useState(false);

  useEffect(() => {
    findTests();
  }, []);

  const findTests = params =>
    fetchJson("/lims_sample_reporting/api/sample_reports.json", {
      id: sample.identifier
    }).then(reports => {
      setSampleReports(reports);
      setShowReports(true);
    });

  return (
    <Wrapper>
      {!showReports && <span>Loading...</span>}
      {showReports && sampleReports.length == 0 && <p>There are no reports.</p>}
      {showReports && sampleReports.length > 0 && (
        <table className="table table-hover" style={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th>{I18n.t("name")}</th>
              <th>{I18n.t("report_type")}</th>
              <th>{I18n.t("file_name")}</th>
              <th>{I18n.t("void")}</th>
              <th>{I18n.t("download")}</th>
              <th>{I18n.t("time_generated")}</th>
            </tr>
          </thead>
          <tbody>
            {sampleReports.map(report => (
              <tr>
                <td>{report.name}</td>
                <td>{report.report_type}</td>
                <td>{report.filename}</td>
                <td>{report.void ? I18n.t("yes") : I18n.t("no")}</td>
                <td>
                  <a href={report.url} target="_blank">
                    {I18n.t("download")}
                  </a>
                </td>
                <td>
                  {report.generated_at &&
                    moment
                      .utc(report.generated_at)
                      .local()
                      .format("DD/MM/YY HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Wrapper>
  );
}
